import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid';
import FaqSectionLink from '../../../../help-center/components/Topics/FaqSectionLink';
import QuestionPageSecondaryHeader from '../QuestionPage/QuestionPageSecondaryHeader';
import { FaqSection } from '../../../../../api/types/faq-content-api';
import { useMuiMediaQuery } from '../../../../../utilities/hooks/useMuiMediaQuery';

type OtherTopicsProps = {
    otherTopics?: FaqSection[];
};

const OtherTopics = ({ otherTopics }: OtherTopicsProps) => {
    const { isMobile } = useMuiMediaQuery();
    if (!otherTopics) {
        return <></>;
    }

    return (
        <Stack spacing={isMobile ? 2 : 3}>
            <QuestionPageSecondaryHeader>Other topics</QuestionPageSecondaryHeader>
            <Grid container gap={1}>
                {otherTopics.map(({ sectionTitle, url }, index) => (
                    <Grid key={index}>
                        <FaqSectionLink title={sectionTitle} url={url} />
                    </Grid>
                ))}
            </Grid>
        </Stack>
    );
};

export default OtherTopics;
